export default function CTAFinal() {
  return (
    <section className="py-20 md:py-32 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="relative rounded-2xl md:rounded-3xl overflow-hidden mb-10 md:mb-14 mx-auto max-w-2xl aspect-[21/9]">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20flatlay%20with%20earth%20tone%20linen%20garments%20and%20leather%20accessories%20arranged%20on%20warm%20sand%20colored%20textured%20paper%2C%20soft%20afternoon%20sunlight%2C%20film%20grain%20texture%20overlay%2C%20editorial%20photography%20with%20organic%20composition%2C%20peaceful%20Mediterranean%20aesthetic%2C%20gentle%20shadows&width=1400&height=600&seq=cta-final-v2-flatlay&orientation=landscape"
            alt="Pandabuyspreadsheet collection"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>

        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-6">
          Start Exploring the Best
          <br />
          <span className="italic text-accent-500 font-normal">pandabuyspreadsheet</span>
          <br />
          Collections Now
        </h2>

        <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto mb-10 leading-relaxed">
          Thousands of curated items across 14 categories — updated daily. One click away from your
          next favorite find. Stop scrolling through messy links and start browsing like a pro.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/20"
        >
          Enter Spreadsheet Hub
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}